module.exports = __webpack_public_path__ + "static/media/flooring_allImpact_60yd_n.df86bc67.csv";